import { MoviesGrid } from "../components/moviesGrid";
import { Search } from "../components/search";

export function Landing(){
    return (
        <div>
<Search></Search>
            <MoviesGrid></MoviesGrid>
        </div> 
    )
};